import P5Element from "../element";
import type p5 from "p5";

class P5Text extends P5Element {
  content = this.innerHTML;

  connectedCallback() {
    this.style.display = "none";
  }

  draw(p: p5) {
    this.cssContext(p, () => {
      p.text(this.content, 0, 0);
    });
  }
}

customElements.define("p5-text", P5Text);
